import { render } from "./CheckComponent.vue?vue&type=template&id=765f992e&scoped=true"
import script from "./CheckComponent.vue?vue&type=script&lang=js"
export * from "./CheckComponent.vue?vue&type=script&lang=js"

import "./CheckComponent.vue?vue&type=style&index=0&id=765f992e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-765f992e"]])

export default __exports__